// extracted by mini-css-extract-plugin
export default {"multiItem":"FilterItemLocation_multiItem__HI+ku"};